<div class="grid-container border-primary">
  <div class="item1"><app-header></app-header></div>
  
  <div class="item2"><app-menu></app-menu></div>
  <div class="item3"><router-outlet></router-outlet></div>
  <div class="item4 border"><app-right></app-right></div>
  <div class="item5"><app-footer></app-footer></div>

</div>
